// ============================================================================
// post-client-mod -- Post 注册器
//
// 1. 通过 DI 获取 IUserCenterSlotsService，注册 "my-posts" slot 到用户中心
//    （用户管理文章的地方）
// 2. 注册公开页面路由：
//    - /post      — 文章列表页（给访客浏览）
//    - /post/:id  — 文章详情页
//    - /search    — 搜索页面
// 3. 使用 IFetchService 实现 SSR loader（后端直接调用服务，避免 Worker 死锁）
//
// 关键设计：
// - SSR loader 通过 IFetchService 预取数据
// - 浏览器端：IFetchService → BrowserFetchService → 原生 fetch → /api/posts
// - SSR 端：IFetchService → BackendFetchService → 直接调用 PostService（无 HTTP 开销，无死锁）
// ============================================================================
import { PostPanel } from './components/post-panel.js';
import { PostListPage } from './pages/post-list-page.js';
import { PostDetailPage } from './pages/post-detail-page.js';
import { SearchPage } from './pages/search-page.js';
import { CategoryListPage } from './pages/category-list-page.js';
import { TagListPage } from './pages/tag-list-page.js';
import { PostIcon } from './components/icons.js';
/**
 * Post 客户端注册器
 */
export class PostRegistrar {
    constructor(deps) {
        const { userCenterSlots, pageRouteRegistry, fetchService } = deps;
        this.fetchService = fetchService;
        // 1. 注册 "我的文章" slot 到用户中心（管理后台）
        userCenterSlots.registerSlot({
            id: 'my-posts',
            label: '我的文章',
            icon: PostIcon,
            component: PostPanel,
            order: 20,
            modName: 'post-client',
        });
        // 2. 注册公开文章列表页（带 SSR loader）
        pageRouteRegistry.registerPage({
            path: '/post',
            component: PostListPage,
            key: 'post-list',
            meta: {
                title: '文章列表',
            },
            modName: 'post-client',
            loader: async (args) => {
                const searchParams = new URLSearchParams();
                searchParams.set('status', 'published');
                if (args.location.query) {
                    for (const [k, v] of Object.entries(args.location.query)) {
                        if (v != null && k !== 'status')
                            searchParams.set(k, String(v));
                    }
                }
                const url = `/api/posts?${searchParams.toString()}`;
                const response = await this.fetchService.fetch(url, {
                    method: 'GET',
                    headers: args.request?.headers,
                });
                return response.json();
            },
        });
        // 3. 注册公开文章详情页（带 SSR loader）
        pageRouteRegistry.registerPage({
            path: '/post/:id',
            component: PostDetailPage,
            key: 'post-detail',
            meta: {
                title: '文章详情',
            },
            modName: 'post-client',
            loader: async (args) => {
                const id = args.params.id;
                const url = `/api/posts/${id}`;
                const response = await this.fetchService.fetch(url, {
                    method: 'GET',
                    headers: args.request?.headers,
                });
                return response.json();
            },
        });
        // 4. 注册搜索页面（公开）
        pageRouteRegistry.registerPage({
            path: '/search',
            component: SearchPage,
            key: 'post-search',
            meta: {
                title: '搜索文章',
            },
            modName: 'post-client',
        });
        // 5. 注册分类列表页（公开）
        pageRouteRegistry.registerPage({
            path: '/categories',
            component: CategoryListPage,
            key: 'post-categories',
            meta: {
                title: '分类',
            },
            modName: 'post-client',
        });
        // 6. 注册标签列表页（公开）
        pageRouteRegistry.registerPage({
            path: '/tags',
            component: TagListPage,
            key: 'post-tags',
            meta: {
                title: '标签',
            },
            modName: 'post-client',
        });
    }
}
//# sourceMappingURL=post-registrar.js.map